export const animeList = [
  {
    id: "1",
    title: "鬼灭之刃 柱训练篇",
    category: "日本动漫",
    slug: "guimie-zhuren-xunlian",
    coverImage: "https://readdy.ai/api/search-image?query=A%20breathtaking%20Japanese%20anime%20key%20visual%20featuring%20a%20young%20swordsman%20with%20flame-patterned%20kimono%20against%20a%20dark%20night%20sky%20with%20cherry%20blossoms%2C%20dramatic%20lighting%2C%20watercolor%20aesthetic%2C%20cinematic%20composition%2C%20Japanese%20woodblock%20print%20style%20with%20modern%20anime%20rendering%2C%20intense%20energy%20emanating%20from%20character%2C%20flat%20simple%20dark%20background&width=800&height=1120&seq=anime-cover-01&orientation=portrait",
    episode: "第8集",
    updateTime: "2026-07-04",
    rating: 9.5,
    views: "1289万",
    description: "时值日本大正时期，卖炭少年炭治郎一家人遭到鬼的袭击，妹妹祢豆子变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。",
    tags: ["热血", "战斗", "奇幻", "少年"],
    episodes: [
      { num: 1, title: "为了讨伐鬼舞辻无惨" },
      { num: 2, title: "水之呼吸 继承者" },
      { num: 3, title: "柱合会议" },
      { num: 4, title: "炭治郎的决意" },
      { num: 5, title: "霞柱·时透无一郎" },
      { num: 6, title: "恋柱·甘露寺蜜璃" },
      { num: 7, title: "岩柱·悲鸣屿行冥" },
      { num: 8, title: "最终决战开始" },
    ],
    isHot: true,
    isNew: true,
  },
  {
    id: "2",
    title: "葬送的芙莉莲",
    category: "日本动漫",
    slug: "zangsong-fulilian",
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20female%20elf%20mage%20with%20long%20silver%20hair%20in%20a%20fantasy%20world%2C%20holding%20a%20magic%20staff%2C%20surrounded%20by%20floating%20magical%20particles%20and%20flowers%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20painterly%20anime%20art%20style%2C%20warm%20sunset%20lighting%2C%20simple%20gradient%20background&width=800&height=1120&seq=anime-cover-02&orientation=portrait",
    episode: "全28集",
    updateTime: "2026-06-28",
    rating: 9.7,
    views: "2560万",
    description: "打倒魔王的勇者一行人冒险结束后，精灵魔法使芙莉莲踏上了了解人类的旅程。时光流逝，曾经的伙伴们逐渐老去，而她依然年轻如初...",
    tags: ["治愈", "奇幻", "冒险", "成长"],
    episodes: [
      { num: 1, title: "冒险的结束" },
      { num: 2, title: "幻影鬼" },
      { num: 3, title: "灵魂安眠之地" },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: "3",
    title: "药屋少女的呢喃",
    category: "日本动漫",
    slug: "yaowu-shaonv-dinan",
    coverImage: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20girl%20with%20green%20hair%20and%20freckles%20in%20ancient%20Chinese%20palace%20attire%2C%20holding%20medicinal%20herbs%2C%20set%20in%20a%20beautiful%20Imperial%20court%20garden%20with%20lotus%20pond%20and%20traditional%20architecture%2C%20warm%20autumn%20tones%2C%20detailed%20textile%20patterns%2C%20simple%20warm%20beige%20background&width=800&height=1120&seq=anime-cover-03&orientation=portrait",
    episode: "第24集",
    updateTime: "2026-07-03",
    rating: 9.4,
    views: "1560万",
    description: "自幼在花街长大的药师少女猫猫，被卖入后宫担任侍女。凭借丰富的药学知识，她在神秘的后宫中破解一个又一个谜团。",
    tags: ["推理", "宫廷", "治愈", "悬疑"],
    episodes: [
      { num: 1, title: "猫猫" },
      { num: 2, title: "玉叶妃" },
      { num: 3, title: "毒与药" },
    ],
    isHot: true,
    isNew: true,
  },
  {
    id: "4",
    title: "咒术回战 第二季",
    category: "日本动漫",
    slug: "zhoushu-huizhan-s2",
    coverImage: "https://readdy.ai/api/search-image?query=A%20powerful%20anime%20character%20with%20spiky%20white%20hair%20and%20blindfold%2C%20surrounded%20by%20cursed%20energy%20in%20purple%20and%20blue%20tones%2C%20dynamic%20action%20pose%2C%20urban%20Tokyo%20cityscape%20background%20at%20night%2C%20intense%20atmosphere%2C%20modern%20shonen%20anime%20style%2C%20high%20contrast%20lighting%2C%20simple%20dark%20background&width=800&height=1120&seq=anime-cover-04&orientation=portrait",
    episode: "全23集",
    updateTime: "2026-06-15",
    rating: 9.6,
    views: "3120万",
    description: "最强的咒术师五条悟与夏油杰的过去即将揭晓。涩谷事变篇，咒术界的全面战争一触即发。",
    tags: ["战斗", "热血", "超能力", "黑暗"],
    episodes: [
      { num: 1, title: "怀玉" },
      { num: 2, title: "怀玉-贰" },
      { num: 3, title: "涩谷事变" },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: "5",
    title: "间谍过家家 第二季",
    category: "日本动漫",
    slug: "jiandie-guojiajia-s2",
    coverImage: "https://readdy.ai/api/search-image?query=A%20charming%20family%20portrait%20of%20three%20anime%20characters%2C%20a%20suave%20man%20in%20suit%2C%20an%20elegant%20woman%20in%20red%20dress%2C%20and%20a%20cute%20pink-haired%20little%20girl%2C%20all%20smiling%20warmly%2C%20set%20against%20a%20cozy%20European%20city%20backdrop%2C%20pastel%20color%20scheme%2C%20heartwarming%20atmosphere%2C%20simple%20warm%20cream%20background&width=800&height=1120&seq=anime-cover-05&orientation=portrait",
    episode: "第37集",
    updateTime: "2026-07-02",
    rating: 9.3,
    views: "1980万",
    description: "为了执行秘密任务，顶级间谍黄昏组建了一个临时家庭。他万万没想到，「妻子」是个职业杀手，「女儿」是个拥有读心能力的超能力者。",
    tags: ["喜剧", "日常", "温馨", "谍战"],
    episodes: [
      { num: 1, title: "代号：枭" },
      { num: 2, title: "家庭教师" },
      { num: 3, title: "企鹅公园" },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: "6",
    title: "斗破苍穹 年番",
    category: "国产动漫",
    slug: "doupo-cangqiong",
    coverImage: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20martial%20artist%20with%20flowing%20black%20hair%20in%20traditional%20hanfu%20robes%2C%20wielding%20a%20massive%20flame-covered%20sword%2C%20standing%20on%20a%20mountain%20peak%20with%20dragons%20soaring%20in%20the%20sky%2C%20epic%20fantasy%20scene%2C%20Chinese%20donghua%203D%20animation%20style%2C%20dramatic%20clouds%20and%20sunset%2C%20simple%20dark%20gradient%20background&width=800&height=1120&seq=anime-cover-06&orientation=portrait",
    episode: "第112集",
    updateTime: "2026-07-04",
    rating: 9.2,
    views: "4520万",
    description: "天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然变成了废人。种种打击接踵而至，就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现...",
    tags: ["玄幻", "热血", "战斗", "国漫之光"],
    episodes: [
      { num: 1, title: "纳兰嫣然" },
      { num: 2, title: "废柴之名" },
      { num: 3, title: "炼药大会" },
    ],
    isHot: true,
    isNew: true,
  },
  {
    id: "7",
    title: "完美世界",
    category: "国产动漫",
    slug: "wanmei-shijie",
    coverImage: "https://readdy.ai/api/search-image?query=A%20powerful%20young%20cultivator%20with%20glowing%20golden%20eyes%20in%20ancient%20Chinese%20armor%2C%20surrounded%20by%20mystical%20beasts%20and%20floating%20islands%2C%20primordial%20chaos%20energy%20swirling%20around%2C%20epic%20high%20fantasy%20Chinese%20donghua%20style%2C%20rich%20gold%20and%20jade%20color%20palette%2C%20simple%20dark%20cosmic%20background&width=800&height=1120&seq=anime-cover-07&orientation=portrait",
    episode: "第178集",
    updateTime: "2026-07-03",
    rating: 9.1,
    views: "3890万",
    description: "一粒尘可填海，一根草斩尽日月星辰。在乱世中崛起，少年石昊一步步走向强者之路，探寻天地间的终极奥秘。",
    tags: ["玄幻", "仙侠", "热血", "国漫"],
    episodes: [
      { num: 1, title: "大荒" },
      { num: 2, title: "柳神" },
      { num: 3, title: "鲲鹏宝术" },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: "8",
    title: "凡人修仙传",
    category: "国产动漫",
    slug: "fanren-xiuxianzhuan",
    coverImage: "https://readdy.ai/api/search-image?query=A%20humble-looking%20young%20man%20in%20simple%20grey%20robes%20with%20a%20small%20green%20bottle%20glowing%20in%20his%20hand%2C%20standing%20in%20a%20misty%20bamboo%20forest%2C%20ethereal%20spiritual%20energy%20flowing%2C%20Chinese%203D%20donghua%20realistic%20style%2C%20muted%20earthy%20tones%20with%20subtle%20green%20accents%2C%20simple%20dark%20forest%20background&width=800&height=1120&seq=anime-cover-08&orientation=portrait",
    episode: "第85集",
    updateTime: "2026-07-01",
    rating: 9.4,
    views: "2780万",
    description: "一个普通的山村穷小子，偶然之下进入了一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙。",
    tags: ["仙侠", "成长", "凡人流", "国漫"],
    episodes: [
      { num: 1, title: "韩立" },
      { num: 2, title: "七玄门" },
      { num: 3, title: "小绿瓶" },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: "9",
    title: "庆余年 第二季",
    category: "电视剧",
    slug: "qingyunian-s2",
    coverImage: "https://readdy.ai/api/search-image?query=A%20handsome%20Chinese%20actor%20in%20elegant%20ancient%20%20court%20costume%20with%20intricate%20embroidery%2C%20standing%20in%20a%20grand%20imperial%20%20palace%20hall%20with%20golden%20pillars%2C%20dramatic%20cinematic%20lighting%2C%20historical%20%20Chinese%20costume%20drama%20aesthetic%2C%20regal%20atmosphere%2C%20simple%20dark%20background&width=800&height=1120&seq=drama-cover-01&orientation=portrait",
    episode: "第36集",
    updateTime: "2026-07-04",
    rating: 9.6,
    views: "5680万",
    description: "范闲经历了生死危机后重返京都，面对更加复杂的朝堂斗争和个人命运选择。二皇子的阴谋、庆帝的野心、以及身世之谜，一切将揭开序幕。",
    tags: ["古装", "权谋", "喜剧", "热门剧"],
    episodes: [
      { num: 1, title: "归来" },
      { num: 2, title: "北齐密使" },
      { num: 3, title: "朝堂风暴" },
    ],
    isHot: true,
    isNew: true,
  },
  {
    id: "10",
    title: "繁花",
    category: "电视剧",
    slug: "fanhua",
    coverImage: "https://readdy.ai/api/search-image?query=A%20stylish%20Chinese%20drama%20scene%20with%20a%20man%20in%20sharp%201990s%20Shanghai%20suit%2C%20standing%20by%20the%20Huangpu%20River%20at%20night%20with%20neon%20lights%20reflecting%20on%20water%2C%20nostalgic%20golden%20era%20atmosphere%2C%20cinematic%20wong%20kar%20wai%20aesthetic%2C%20rich%20amber%20and%20gold%20tones%2C%20simple%20dark%20background&width=800&height=1120&seq=drama-cover-02&orientation=portrait",
    episode: "全30集",
    updateTime: "2026-06-20",
    rating: 9.8,
    views: "6820万",
    description: "九十年代的上海，青年阿宝凭借改革开放的春风和自己的打拼，在商界崭露头角。一条黄河路，一个上海滩，一段不平凡的人生故事。",
    tags: ["年代", "商战", "爱情", "经典"],
    episodes: [
      { num: 1, title: "黄河路" },
      { num: 2, title: "至真园" },
      { num: 3, title: "爷叔" },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: "11",
    title: "哪吒之魔童闹海",
    category: "电影",
    slug: "nezha-motong-naohai",
    coverImage: "https://readdy.ai/api/search-image?query=A%20young%20rebellious%20boy%20with%20flaming%20red%20hair%20and%20magical%20powers%2C%20riding%20on%20wind%20fire%20wheels%2C%20surrounded%20by%20Chinese%20mythological%20sea%20dragons%20and%20stormy%20waves%2C%20epic%20animated%20film%20style%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20dynamic%20action%20composition%2C%20simple%20dark%20background&width=800&height=1120&seq=movie-cover-01&orientation=portrait",
    episode: "HD高清",
    updateTime: "2026-07-04",
    rating: 9.5,
    views: "12500万",
    description: "天劫之后，哪吒和敖丙的灵魂虽然保住，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，过程中却遇到重重困难。",
    tags: ["动画", "神话", "热血", "国漫电影"],
    episodes: [],
    isHot: true,
    isNew: true,
  },
  {
    id: "12",
    title: "流浪地球3",
    category: "电影",
    slug: "liulang-diqiu-3",
    coverImage: "https://readdy.ai/api/search-image?query=A%20massive%20sci-fi%20space%20station%20orbiting%20a%20frozen%20Earth%20with%20blue%20plasma%20engines%2C%20astronauts%20floating%20in%20the%20foreground%2C%20epic%20cinematic%20Chinese%20sci-fi%20film%20aesthetic%2C%20cold%20blue%20and%20steel%20gray%20color%20scheme%2C%20grand%20scale%2C%20simple%20dark%20space%20background&width=800&height=1120&seq=movie-cover-02&orientation=portrait",
    episode: "HD高清",
    updateTime: "2026-06-30",
    rating: 9.3,
    views: "9800万",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了为期2500年的流浪之旅。前所未有的危机降临，人类命运面临最终抉择。",
    tags: ["科幻", "灾难", "冒险", "国产大片"],
    episodes: [],
    isHot: true,
    isNew: false,
  },
];

export const categories = [
  { name: "日本动漫", slug: "japanese-anime", icon: "ri-movie-2-line", count: 5200 },
  { name: "国产动漫", slug: "chinese-anime", icon: "ri-film-line", count: 3800 },
  { name: "电视剧", slug: "tv-series", icon: "ri-tv-2-line", count: 4500 },
  { name: "电影", slug: "movies", icon: "ri-movie-line", count: 6800 },
  { name: "热血冒险", slug: "action-adventure", icon: "ri-fire-line", count: 2100 },
  { name: "恋爱日常", slug: "romance-daily", icon: "ri-heart-line", count: 1600 },
  { name: "搞笑喜剧", slug: "comedy", icon: "ri-emotion-laugh-line", count: 1800 },
  { name: "悬疑推理", slug: "mystery", icon: "ri-search-eye-line", count: 950 },
];

export const reviews = [
  {
    name: "星辰大海",
    role: "资深漫迷 / VIP会员",
    content: "从大学开始就在樱花动漫追番了，资源更新速度真的没话说！画质清晰流畅，分类也很齐全，日本新番、国产动漫、热门剧场版一应俱全。现在已经推荐给身边所有喜欢看动漫的朋友了，真的良心网站。",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20with%20stylish%20haircut%2C%20wearing%20casual%20black%20hoodie%2C%20warm%20friendly%20expression%2C%20simple%20studio%20portrait%20lighting%2C%20clean%20neutral%20gray%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-01&orientation=squarish",
  },
  {
    name: "雨落樱花",
    role: "追番达人 / 三年用户",
    content: "樱花动漫网的分类做得特别好，想看什么类型的动漫都能快速找到。而且更新快、弹幕氛围也好。最重要的是免费高清，不用开各种会员就能畅享优质动漫资源，对动漫爱好者来说简直太友好了！",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20long%20dark%20hair%2C%20wearing%20a%20casual%20pastel%20sweater%2C%20gentle%20smile%2C%20simple%20studio%20portrait%20with%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20warm%20and%20friendly%20headshot&width=200&height=200&seq=avatar-02&orientation=squarish",
  },
  {
    name: "风吹麦浪",
    role: "二次元爱好者 / 活跃用户",
    content: "能免费看高清动漫真的太幸福了！我每天下班回家第一件事就是打开樱花动漫网看看今天更新了什么新番。界面设计也很舒服，没有乱七八糟的广告弹窗，追番体验一级棒！",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20with%20retro%20round%20glasses%2C%20wearing%20a%20denim%20jacket%2C%20bright%20energetic%20smile%2C%20simple%20studio%20portrait%20with%20warm%20lighting%2C%20clean%20light%20background%2C%20casual%20and%20friendly%20headshot%20style&width=200&height=200&seq=avatar-03&orientation=squarish",
  },
];

export const hotRanking = [
  { rank: 1, title: "鬼灭之刃 柱训练篇", category: "日本动漫", views: "1289万", rating: 9.5, slug: "guimie-zhuren-xunlian" },
  { rank: 2, title: "葬送的芙莉莲", category: "日本动漫", views: "2560万", rating: 9.7, slug: "zangsong-fulilian" },
  { rank: 3, title: "庆余年 第二季", category: "电视剧", views: "5680万", rating: 9.6, slug: "qingyunian-s2" },
  { rank: 4, title: "哪吒之魔童闹海", category: "电影", views: "12500万", rating: 9.5, slug: "nezha-motong-naohai" },
  { rank: 5, title: "咒术回战 第二季", category: "日本动漫", views: "3120万", rating: 9.6, slug: "zhoushu-huizhan-s2" },
  { rank: 6, title: "繁花", category: "电视剧", views: "6820万", rating: 9.8, slug: "fanhua" },
  { rank: 7, title: "斗破苍穹 年番", category: "国产动漫", views: "4520万", rating: 9.2, slug: "doupo-cangqiong" },
  { rank: 8, title: "凡人修仙传", category: "国产动漫", views: "2780万", rating: 9.4, slug: "fanren-xiuxianzhuan" },
];

export const weeklySchedule = [
  { day: "周一", animes: ["鬼灭之刃", "间谍过家家", "青之驱魔师"] },
  { day: "周二", animes: ["斗破苍穹", "完美世界", "遮天"] },
  { day: "周三", animes: ["药屋少女的呢喃", "葬送的芙莉莲", "迷宫饭"] },
  { day: "周四", animes: ["庆余年", "繁花", "三体"] },
  { day: "周五", animes: ["咒术回战", "我推的孩子", "物理魔法使"] },
  { day: "周六", animes: ["鬼灭之刃", "不死少女", "杀手寓言"] },
  { day: "周日", animes: ["夏日重现", "Lycoris Recoil", "孤独摇滚"] },
];